import { render, staticRenderFns } from "./BtnResetChallenge.vue?vue&type=template&id=04b79881"
import script from "./BtnResetChallenge.vue?vue&type=script&lang=js"
export * from "./BtnResetChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports